<template>
  <mdb-container fluid class="mt-3">
    <h4>Hakusananalytiikka</h4>

    <!-- KPI-kortit -->
    <mdb-row class="mb-4" v-if="summary">
      <mdb-col md="2" v-for="kpi in kpiCards" :key="kpi.label">
        <div class="card shadow-sm h-100 py-2" :class="kpi.borderClass">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-uppercase mb-1" :class="kpi.textClass">{{ kpi.label }}</div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">{{ kpi.value }}</div>
              </div>
              <div class="col-auto">
                <i class="fas fa-2x text-gray-300" :class="kpi.icon"></i>
              </div>
            </div>
          </div>
        </div>
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <!-- Top hakusanat -->
      <mdb-col md="6" class="mb-4">
        <h6>Top hakusanat</h6>
        <DataTableAG
          :columns="topSearchwordCols"
          :getcontentpath="gettopsearchwordspath"
          jsonobject="topsearchwords"
          :key="componentKey"
          width="1050px"
          height="750px"
        />
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import DataTableAG from "@/components/DataTableAG.vue";
import { mdbContainer, mdbRow, mdbCol } from "mdbvue";

export default {
  name: "SearchPerformedAnalyticsDashboard",
  components: { DataTableAG, mdbContainer, mdbRow, mdbCol },
  data() {
    return {
      summary: null,
      componentKey: 0,
      topSearchwordCols: [
        {
          field: "searchword",
          headerName: "Hakusana",
          flex: 2,
          sortable: true,
          filter: true,
        },
        {
          field: "count",
          headerName: "Esiintymiä",
          flex: 1,
          sortable: true,
          filter: true,
        },
      ],
    };
  },
  computed: {
    gettopsearchwordspath() {
      return `/1.0/front/searchperformed/analytics/top-searchwords?limit=1000`;
    },
    getsummarypath() {
      return `/1.0/front/searchperformed/analytics/summary`;
    },
    kpiCards() {
      if (!this.summary) return [];
      return [
        {
          label: "Haut yhteensä",
          value: this.summary.total_searches?.toLocaleString("fi-FI"),
          icon: "fa-search",
          borderClass: "border-left-blue",
          textClass: "text-primary",
        },
        {
          label: "Hakusanoja",
          value: this.summary.unique_searchwords?.toLocaleString("fi-FI"),
          icon: "fa-font",
          borderClass: "border-left-info",
          textClass: "text-info",
        },
      ];
    },
  },
  mounted() {
    this.loadSummary();
  },
  methods: {
    loadSummary() {
      this.$http
        .get(this.getsummarypath)
        .then((response) => {
          if (response.status == 200) {
            this.summary = response.data["summary"];
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("summary_load_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.text-xs { font-size: .7rem; }
.text-gray-800 { color: #5a5c69; }
.text-gray-300 { color: #dddfeb; }
.border-left-blue { border-left: .25rem solid #4e73df !important; }
.border-left-info { border-left: .25rem solid #36b9cc !important; }
</style>
